export default "__VITE_ASSET__B6QBy1SD__"